import { Breadcrumbs, Grid, Link, Typography } from "@mui/material"
import TopSideBar from "../../components/TopSideBar"
import PageContainer from "../../components/common/PageContainer"
import TitlebarAction from "../../components/common/TitlebarActions"
import { PADDING_BASE } from "../../assets/Styles"
import PersonsManagement from "../../components/PersonsManagement"
import Copyright from "../../components/common/Copyright"

export default function PersonsManagementPage({ setBlockScreen }: any) {
  return (<>
    <TopSideBar currentSection='persons' hideProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="400">
            Gestión de Usuarios
          </Typography>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
            Personas
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Administrar Personas' />

      <PersonsManagement setBlockScreen={setBlockScreen} />
      <Copyright />

    </PageContainer>
  </>)
}